import {db} from "../firebase";
import {Collections} from "./collections";
import {FollowerInterface} from "../db/models/follower";
import {MissingType} from "../db/models/extra";

export const getFollowersByRmId = async (rmId: string) => {
    if (!rmId) return Promise.reject();

    const usersSnap = await db
        .collection(Collections.USERS)
        .orderBy(`follows.${rmId}`)
        .get();
    const users = usersSnap.docs.map((doc) => doc.data());
    const followers = users.map(async (user) => {
        return {
            user,
            cv: await db
                .collection(Collections.STUDENT_CVS)
                .doc(user.id)
                .get()
                .then((doc) => {
                    if (doc.exists) {
                        return doc.data();
                    }
                    return null;
                }),
        } as FollowerInterface;
    });

    return Promise.all(followers);
};

export const getFollowersFromIds = (studentIds: string[]) => {
    if (!studentIds) return Promise.reject();

    let followers: Promise<FollowerInterface>[] = [];
    studentIds.forEach((studentId) => {
        followers.push(
            db
                .collection(Collections.USERS)
                .doc(studentId)
                .get()
                .then(async (doc) => {
                    const user = doc.exists ? doc.data() : null;

                    return {
                        user,
                        cv: await db
                            .collection(Collections.STUDENT_CVS)
                            .doc(studentId)
                            .get()
                            .then((doc) => {
                                if (doc.exists) {
                                    return doc.data();
                                }
                                return null;
                            }),
                    } as FollowerInterface;
                })
        );
    });
    return Promise.all(followers);
};

export const addContact = (data: MissingType) => {
    if (!data) return Promise.reject();

    return db.collection(Collections.CONTACTS).add(data);
};

export const addDemo = (data: MissingType) => {
    if (!data) return Promise.reject();

    return db.collection(Collections.DEMO).add(data);
};

export const addCall = (data: MissingType) => {
    if (!data) return Promise.reject();

    return db.collection(Collections.CALLS).add(data);
};

export const addPremiumRequest = (data: MissingType) => {
    if (!data) return Promise.reject();

    return db.collection(Collections.PREMIUM_REQUESTS).add(data);
};
